<template>
	<div class="font-mono">
		<span class="text-gray-100" :class="timeClass">{{ timeFormatted }}</span>
		<span v-if="durationFormatted" class="text-gray-400 duration">/{{ durationFormatted }}</span>
	</div>
</template>

<script>
import {humanDurationShort} from 'shared/utils/humanDuration'

export default {
	name: 'PlayerTimeIndicator',
	props: {
		timeMs: {
			type: Number,
			required: true,
		},
		durationMs: {
			type: Number,
			default: null,
		},
		timeClass: {
			type: String,
			default: '',
		},
	},
	computed: {
		timeFormatted() {
			return humanDurationShort(this.timeMs)
		},
		durationFormatted() {
			if (!this.durationMs || this.durationMs === Infinity) return null
			return humanDurationShort(this.durationMs)
		},
	},
}
</script>

<style scoped>
@container controls (max-width: 290px) {
	.duration {
		display: none;
	}
}
</style>
